module.exports = __webpack_public_path__ + "static/media/IlotB_synthese_3.7b8c3a24.webp";